<footer class="mt-12">
  <div class="py-4 lg:py-6 px-[16px] lg:px-[64px] xl:container">
    <div class="flex flex-col lg:flex-row">
      <div class="flex-1">
        <div class="max-w-[912px]">
          <p>{{(theme === 'Storey' ? 'storey.footer.text' : 'footer.text') | translate}}</p>
        </div>
      </div>
      <div class="mb-4 lg:mb-0 lg:ml-4">
        <ul class="m-0 px-0 mt-4 list-none list-outside">
          <li class="ml-0"><a [href]="getLinkPrivacyPolicy()" class=" no-underline text-black">Privacy Policy</a></li>
          <li class="ml-0 mt-2">{{(theme === 'Storey' ? 'storey.footer.copyright-text' : 'footer.copyright-text') | translate}}</li>
          <li class="ml-0 mt-2">Powered by: Rezpage Property Management system</li>
          <li class="ml-0 mt-2" *ngIf="getPhoneNumber()">Need help? - <a [href]="gitLinkPhoneNumber()" class="text-[black]">{{getPhoneNumber()}}</a></li>
        </ul>
      </div>
      <div class="block lg:hidden h-[216px]">
      </div>
    </div>
  </div>
</footer>